import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureButton } from '@/ui/svg-icon';
import globalStore from '@/store/global';
import Examples from '@/components/examples';
import ScrollToTop from '@/components/scroll-top';
import navbarStore from '@/store/navbar';
import { debounce } from 'lodash-es';
import exampleStore from '@/components/examples/store';

const ExamplesPage = observer(() => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const scrollRef = useRef(null)

  const onScroll = debounce((e) => {
    setShowScrollToTop(e.target.scrollTop > window.innerHeight)

    if(!exampleStore.data.npt) return;

    const scrollTop = e.target.scrollTop;
    const windowHeight = e.target.clientHeight;
    const documentHeight = e.target.scrollHeight;
    const distance = 235;

    if (scrollTop + windowHeight >= documentHeight - distance) {
      exampleStore.getExampleList()
    }
    
  }, 300);

  return (
    <div className="w-full h-full bg-white flex flex-col">
      <div className="w-full h-72px flex items-center">
        <img 
          src="https://p2.ssl.qhimg.com/t110b9a93011454075a4c450e5f.png" 
          className={[
            'size-24px ml-24px mr-16px cursor-pointer',
            navbarStore.isCollapse ? "ml-60px" : "ml-24px"
          ]}
          onClick={() => {
            globalStore.navigate("/")
          }}
        />
        <div className='font-bold text-20px text-black'>精彩作品</div>
      </div>
      <div 
        onScroll={onScroll}
        ref={scrollRef}
        className='w-full h-0 flex-grow overflow-auto nw-no-scroll'
      >
        <div className='mt-38px text-center text-40px text-black mb-36px leading-56px'>
          来自纳米用户的精彩作品
        </div>
        <div className='w-full'>
          <Examples scene="examples" />
        </div>
      </div>
      {
        showScrollToTop
        ? (
          <ScrollToTop 
            onClick={() => {
              scrollRef?.current?.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              });
            }}
            className="absolute right-30px bottom-75px bg-white"
          />
        )
        : null
      }
    </div>
  );
});

export default ExamplesPage;